type TextAreaWrapperConstsProps = {
  iconSize: {
    small: string;
    medium: string;
    large: string;
  };
  iconOffset: {
    small: string;
    medium: string;
    large: string;
  };
};

export const textAreaConsts = {
  paddingWithoutIcon: {
    small: '4px 10px',
    medium: '8px 12px',
    large: '12px 16px',
  },
  paddingWithIcon: {
    small: {
      left: '4px 10px 4px 32px',
      right: '4px 32px 4px 10px',
    },
    medium: {
      left: '8px 12px 8px 40px',
      right: '8px 40px 8px 12px',
    },
    large: {
      left: '12px 16px 12px 44px',
      right: '12px 44px 12px 16px',
    },
  },
};

export const textAreaWrapperConsts: TextAreaWrapperConstsProps = {
  iconSize: {
    small: '20px',
    medium: '24px',
    large: '24px',
  },
  iconOffset: {
    small: '7px',
    medium: '9px',
    large: '13px',
  },
};
